import Vue from 'vue'
import { DataService } from '@/services/DataService.js'

export const namespaced = true

export const state = {
  relations: {}
}

function entityKey (entityCode, entityId) {
  return entityCode + '_' + entityId
}

export const getters = {
  getRelations (state) {
    return (entityCode, entityId) => {
      return state.relations[entityKey(entityCode, entityId)]
    }
  }
}

export const mutations = {
  PUT_RELATIONS (state, { entityCode, entityId, relations }) {
    Vue.set(state.relations, entityKey(entityCode, entityId), relations)
  }
}

export const actions = {
  async load ({ commit, getters }, { entityCode, entityId }) {
    const { data: { entityRelations } } = await DataService.getCrossEntitiesRelations({ entityCode, entityId })
    commit('PUT_RELATIONS', { entityCode, entityId, relations: entityRelations })
  }
}
